// src/components/navigation/NavBar.jsx (or .js)
import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

import LangSwitcher from "../LangSwitcher";
import { GlassPanel } from "../GlassPanel";
import { IFUIcon } from "../icons/IFUIcon";
import { LogoLink } from "../LogoLink";

function NavBar({ className = "" }) {
  const { t } = useTranslation();

  return (
    <header
      className={`
        flex justify-center w-full px-4 pt-3 z-40
        ${className}
      `}
    >
      <div className="w-full ">
        <div className="flex items-center justify-between gap-4">
          {/* Brand / Logo – same family as WebsiteNavBar, but neutral for tool */}
          <LogoLink />

          <div className="flex items-center gap-2">
            <LangSwitcher />

            <Link
              to="/recording/guide"
              className="primary-button-small !flex-row gap-2 !text-greyscale-1"
            >
              <IFUIcon className="h-6 w-6 fill-greyscale-1" />
              <p>{t("nav.guide" || "Guide")}</p>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}

export default React.memo(NavBar);
